import { useRef } from 'react';
import { NavigationContainerRefWithCurrent } from '@react-navigation/native';

import { analyticsClient } from './client';

export const useAnalytics = (
	navigationRef: NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>,
) => {
	const routeNameRef = useRef<string>();

	const onReady = () => {
		routeNameRef.current = navigationRef.current?.getCurrentRoute()?.name;
	};

	const onStateChange = () => {
		const previousRouteName = routeNameRef.current;
		const currentRouteName = navigationRef.current?.getCurrentRoute()?.name;

		if (!currentRouteName || previousRouteName === currentRouteName) {
			return;
		}

		routeNameRef.current = currentRouteName;

		return analyticsClient.screen(currentRouteName);
	};

	return {
		onReady,
		onStateChange,
	};
};
